import { Injectable } from '@angular/core';

@Injectable()
export class NavbarService {
  visible: boolean;
  constructor() {
    this.visible = true;
  }

  hide() {
    this.visible = false;
  }

  show() {
    this.visible = true;
  }

}



// WEBPACK FOOTER //
// ./src/app/service/navbar.service.ts